import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const ArrowIcon = ({ size, color, deg, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, color: color, deg: deg },
    React.createElement("path", { d: "M11 5.414l3.293 3.293a.999.999 0 1 0 1.414-1.414l-5-5a.999.999 0 0 0-1.414 0l-5 5a.997.997 0 0 0 0 1.414.999.999 0 0 0 1.414 0L9 5.414V17a1 1 0 1 0 2 0V5.414z" }),
    React.createElement("use", { fill: color, fillRule: "evenodd" })));
export const Arrow = iconGenerator(ArrowIcon);
//# sourceMappingURL=Arrow.js.map